const GROUP_OPTION_LIST_MAX_LENGTH = 5;

export const useOptionListExpand = () => {
  const expandedGroupKeys = ref([]);

  const resolveGroupKey = (group) =>
    `${group?.group_code || ""}-${group?.title || ""}`;

  const isGroupExpanded = (group) => {
    const groupKey = resolveGroupKey(group);
    return (
      expandedGroupKeys.value.includes(groupKey) ||
      (group?.option_list?.length || 0) <= GROUP_OPTION_LIST_MAX_LENGTH
    );
  };

  const getGroupOptionList = (group) => {
    if (isGroupExpanded(group)) {
      return group?.option_list || [];
    }

    return (group?.option_list || []).slice(0, GROUP_OPTION_LIST_MAX_LENGTH);
  };

  const toggleGroupExpand = (group) => {
    const groupKey = resolveGroupKey(group);
    if (isGroupExpanded(group)) {
      expandedGroupKeys.value = expandedGroupKeys.value.filter(
        (key) => key !== groupKey
      );
      return;
    }
    expandedGroupKeys.value.push(groupKey);
  };

  return {
    isGroupExpanded,
    getGroupOptionList,
    toggleGroupExpand,
  };
};
